import { render, staticRenderFns } from "./oea-ejercicios.vue?vue&type=template&id=7a84987c&scoped=true"
import script from "./oea-ejercicios.vue?vue&type=script&lang=js"
export * from "./oea-ejercicios.vue?vue&type=script&lang=js"
import style0 from "./oea-ejercicios.vue?vue&type=style&index=0&id=7a84987c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a84987c",
  null
  
)

export default component.exports